import { IListProps, List as FluentList } from "@fluentui/react";

export type ListProps = IListProps;

export const List = FluentList;
